import ChangeDealModal from './ChangeDealModal';
import ViewNegotiation from './ViewNegotiation';
import CreateNegotiation from './CreateNegotiation';

const mapping = {
  'change-deal': ChangeDealModal,
  'view-negotiation': ViewNegotiation,
  'create-negotiation': CreateNegotiation
};

export default mapping;
